"use client";

import { useAuth } from "@/components/AuthContext";
import { motion, useReducedMotion } from "framer-motion";
import Link from "next/link";

export function LandingCTA() {
  const { user } = useAuth();
  const shouldReduceMotion = useReducedMotion();

  return (
    <section className="bg-[#0F0F14] py-16 md:py-24">
      <div className="mx-auto max-w-4xl px-4 text-center sm:px-6 lg:px-8">
        <motion.div
          initial={shouldReduceMotion ? false : { opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.35 }}
        >
          <h2 className="text-3xl font-bold tracking-[-0.035em] text-white md:text-5xl">
            {user ? "Ready for another conversation?" : "Try one conversation now"}
          </h2>
          <p className="mx-auto mb-8 mt-4 max-w-2xl text-lg leading-8 text-gray-400">
            {user
              ? "Open the app and continue with your saved language and practice tools."
              : "Choose a language, speak for five minutes, and decide what you think after you have tried it."}
          </p>
          <Link
            href={user ? "/" : "#demo"}
            className="inline-flex items-center justify-center whitespace-nowrap rounded-xl bg-[#FD954F] px-8 py-4 text-lg font-bold text-[#1C1C1E] shadow-lg shadow-orange-950/20 transition-colors hover:bg-[#F28747] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-[#0F0F14]"
          >
            {user ? "Go to App" : "Start free demo"}
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
